<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_confirm_modal">
            <div class="modal-content" data-cy="container_confirm_modal_content">
                <div class="bg-white w-full rounded-5px p-5" data-cy="container_confirm_modal_body">
                    <div class="text-center text-lg pt-3 font-bold text-dark-2 font-main-bold" v-html="title" data-cy="text_confirm_modal_title"></div>
                    <div class="text-center text-base pb-8 pt-3 text-dark-2 font-medium font-main-medium" v-html="message" data-cy="text_confirm_modal_message"></div>
                    <div class="grid grid-cols-2 gap-2" data-cy="container_confirm_modal_btn_wrap">
                        <div>
                            <button class="w-full bg-white text-dark-3 rounded-5px border-2 border-dark-2 shadow capitalize font-medium font-main-medium" @click="clickCancel()" data-cy="btn_confirm_modal_cancel">
                                {{btnCancel}}
                            </button>
                        </div>
                        <div>
                            <button class="w-full bg-gold text-dark-3 rounded-5px border-2 border-transparent shadow capitalize font-medium font-main-medium" @click="clickOk()" data-cy="btn_confirm_modal_ok">
                                {{btnOk}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_confirm_modal_backdrop"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ConfirmModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/button.scss";

    .modal {
        @extend %modal;
    }
    button{
        height: $btn-size-default;
    }
</style>
